// extracted by mini-css-extract-plugin
module.exports = {"contaner":"ShortcutsBar_contaner__Y2Knt","tips":"ShortcutsBar_tips___1nSS"};